import React, {useCallback, useEffect, useState} from "react";
import {
    IonPage,
    useIonAlert,
} from "@ionic/react";
import {useHistory} from "react-router";
import {getManager} from "../ts/manager/Manager";
import HeaderStructure from "./partial/structure/HeaderStructure";
import FooterStructure from "./partial/structure/FooterStructure";
import AppUnavailableView from "./partial/view/AppUnavailableView";
import LoadingScreenView from "./partial/view/LoadingScreenView";
import SideMenuStructure from "./partial/structure/SideMenuStructure";
import TabRouterStructure from "./partial/structure/TabRouterStructure";
import Error404Partial from "./partial/status/Error404Partial";
import eventBus from "../ts/event/EventBus";
import {dispatchRedirectComplete} from "../ts/event/DispatchEvent";
import ChooseTextOptionModal from "./component/modal/ChooseTextOptionModal";

const Base = () =>
{
    const [, setNavigationCount] = useState<number>(0);
    const [, setSimpleState] = useState<any[]>([]);

    const history = useHistory();
    const [ionAlert] = useIonAlert();

    const [items, setItems] = useState<string[]>([]);

    useEffect(() => {
        const newItems = [];
        for (let i = 1; i < 51; i++) {
            newItems.push(`Item ${items.length + i}`);
        }
        setItems([...items, ...newItems]);
    }, []);

    const applyNavigationRoute = useCallback(() =>
    {
        setNavigationCount(getManager().navigation.navigationCount);
    }, []);

    const onRedirectTo = useCallback((event: CustomEvent) =>
    {
        if (!event.detail.path || event.detail.path === getManager().navigation.currentURL)
        {
            refreshPage();
            getManager().ui.isImmediateRedirect = false;
            dispatchRedirectComplete();
            return
        }
        const replace = !!event.detail.replace;
        if(!replace){
            history.push(event.detail.path);
        } else {
            history.replace(event.detail.path);
        }
    }, []);

    const onRefreshPage = useCallback(() =>
    {
        refreshPage();
    }, []);

    const onUpdateBaseState = () =>
    {
        setSimpleState([]);
    }

    const refreshPage = () =>
    {
        getManager().navigation.findRefreshCount++;
        setSimpleState([]);
    }

    useEffect(() =>
    {
        setNavigationCount(getManager().navigation.navigationCount);
        eventBus.on("site.navigation-route-update", applyNavigationRoute);
        eventBus.on("site.redirect-to", onRedirectTo);
        eventBus.on("site.refresh-page", onRefreshPage);
        eventBus.on("site.update-base-state", onUpdateBaseState);
        eventBus.on("site.on-user-log-in-out", refreshPage);
        getManager().ui.ionAlert = ionAlert;
        return () =>
        {
            eventBus.remove("site.navigation-route-update", applyNavigationRoute);
            eventBus.remove("site.redirect-to", onRedirectTo);
            eventBus.remove("site.refresh-page", onRefreshPage);
            eventBus.remove("site.update-base-state", onUpdateBaseState);
            eventBus.remove("site.on-user-log-in-out", refreshPage);
        };
    }, []);


    getManager().navigation.applyCurrentRoute().then();

    const haveInitialData: boolean = getManager().navigation.haveInitialData;
    const canNotProceedErrorMessage: string | null = getManager().navigation.canNotProceedErrorMessage;

    const primaryChoiceViewConfig = getManager().view.getPrimaryChoiceViewConfig()

    const isLockedPage = !haveInitialData  || !!canNotProceedErrorMessage;
    const didLoad = haveInitialData && !canNotProceedErrorMessage;

    return <>
        <IonPage
            id="currentPage"
            className={(isLockedPage ? "locked-page" : "")+" "+(getManager().ui.pauseForAnimation ? "pause-for-animation" : "")+" "+(didLoad ? "did-load" : "")}
        >
            {(() =>
            {
                if (!haveInitialData)
                {
                    return <LoadingScreenView/>
                }

                if (canNotProceedErrorMessage)
                {
                    return <AppUnavailableView
                        message={canNotProceedErrorMessage}
                    />
                }

                return <>

                    {!!primaryChoiceViewConfig &&
                        <HeaderStructure {...primaryChoiceViewConfig.props}/>
                    }
                    <section id="mainContentStart" className="main-section" role="main">
                        {primaryChoiceViewConfig  ? <>
                            {primaryChoiceViewConfig.titleArea}
                            {primaryChoiceViewConfig.mainView}
                        </> : <>
                            <Error404Partial />
                        </>}
                    </section>
                    {primaryChoiceViewConfig?.modalView && <>
                        {primaryChoiceViewConfig.modalView}
                    </>}
                    <FooterStructure/>

                </>
            })()}
        </IonPage>
    </>
}
export default Base